<svelte:window on:updateTime="{updateTime}" />

{rendered}

<script>

export let timestamp = 0;
export let currentTime = 0;

let rendered = "";

$:{
  if (timestamp || currentTime) {
    rendered = render(timestamp, currentTime);
  }
}


import { onMount } from "svelte";
onMount(async () => {
  rendered = render(timestamp, currentTime);
});


function updateTime() {
  rendered = render(date, currentTime);
}

// not exactly international, but we can deal with that later...
// https://muffinman.io/javascript-time-ago-function/
const MONTH_NAMES = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];

const DAY_IN_MS = 86400000; // 24 * 60 * 60 * 1000

function render(timestamp, currentTime) {
  if (!timestamp || !currentTime) return "";
  
  let seconds = Math.round( (currentTime - timestamp) / 1000 );
  let minutes = Math.round( seconds / 60 );
  let isYesterday = new Date(currentTime - DAY_IN_MS).toDateString() === new Date(timestamp).toDateString();

  if (seconds < 60) {
    return 'now';
  } else if (minutes < 60) {
    return `${ minutes } min ago`;
  } else if (minutes < 1440) {
    let hoursAgo = Math.round(minutes / 30) * 0.5;
    let text = hoursAgo == 1 ? " hr ago" : " hrs ago";
    return hoursAgo.toString() + text;
  } else if (isYesterday) {
    return "Yesterday at " + getFormattedTime(timestamp);
  } else {
    return getFormattedDate(new Date(timestamp), false, true) + " at " + getFormattedTime(timestamp);
  }
  
  return getFormattedDate(date);
}


function getFormattedDate(date, prefomattedDate = false, hideYear = false) {
  const day = date.getDate();
  const monthNum = date.getMonth();
  const month = MONTH_NAMES[monthNum];
  const year = date.getFullYear();
  const hours = date.getHours();
  let minutes = date.getMinutes();

  if (minutes < 10) {
    minutes = `0${ minutes }`;
  }

  if (prefomattedDate) {
    return `${ prefomattedDate } at ${ hours }:${ minutes }`;
  }

  if (hideYear) {
    return `${ month } ${ day }`;
  }

  return `${ monthNum + 1 }/${ day }/${ year }`;
}


function getFormattedTime(timestamp) {
  let date = new Date(timestamp);
  
  let period = "am";
  let hour = date.getHours();
  if (hour > 12) {
    period = "pm";
    hour-=12;
  }
  let minute = date.getMinutes();
  if (minute < 10) {
    minute = `0${ minute }`;
  }
  
  return `${hour}:${minute}${period}`;
}



</script>
